import Supports from "../../utils/supports";
import Mixpanel from "../../init/mixpanel";
import { hasParent, isWindowOpen } from "../../init/window";

export default function handleFailureEvent (
    shouldRedirectOnFail,
    failureView,
    initView,
    contextObject,
    hasError = false,
    errorString,
    dispatcher,
    errorStateView
) {
    let retries = Supports.localStorage ? localStorage.getItem('retryAttempts') : null;
    let retryAttempts = retries !== null ? (Number(atob(retries)) / 100) : 0;

    if (retryAttempts !== null && retryAttempts === 0) {
        failureView && failureView.activate.call(contextObject);
    } else if (retryAttempts > 0) {
        --retryAttempts;
        localStorage.setItem('retryAttempts', btoa(String(Number(retryAttempts) * 100)));
        (cb => (Mixpanel.mixpanelInitialized()
            ? Mixpanel.paymentFailed(errorString).finally(() => cb())
            : Promise.resolve().then(() => cb())
            ))(() => {
            if (hasParent || isWindowOpen) {
                try {
                parentWindow.postMessage({
                    name: $data.name || 'opop',
                    data: $data,
                    tx: $tx,
                    success: false
                }, '*');
                return;
                } catch (e) {}
            }
        })

        if (hasError === true) {
            initView(() => setTimeout(() => {
                errorString && dispatcher(errorStateView.actions.updateErrorMessage(errorString, 20));
            }, 0))
        }
        initView()
    } else if ((!retryAttempts || retryAttempts === null) && shouldRedirectOnFail) {
        failureView && failureView.activate.call(contextObject)
    } else if (!retryAttempts && !shouldRedirectOnFail) {
        (cb => (Mixpanel.mixpanelInitialized()
            ? Mixpanel.paymentFailed(errorString).finally(() => cb())
            : Promise.resolve().then(() => cb())
            ))(() => {
            if (hasParent || isWindowOpen) {
                try {
                parentWindow.postMessage({
                    name: $data.name || 'opop',
                    data: $data,
                    tx: $tx,
                    success: false
                }, '*');
                return;
                } catch (e) {}
            }
        })
        if (hasError === true) {
            initView(() => setTimeout(() => {
                errorString && dispatcher(errorStateView.actions.updateErrorMessage(errorString, 20));
            }, 0))
        } 
        initView()
    }
}